export default __webpack_public_path__ + "static/media/presave-site.9f57c03b.svg";